import { render } from "./DonationClarification.vue?vue&type=template&id=0adbae60&scoped=true"
import script from "./DonationClarification.vue?vue&type=script&lang=js"
export * from "./DonationClarification.vue?vue&type=script&lang=js"

import "./DonationClarification.vue?vue&type=style&index=0&id=0adbae60&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0adbae60"

export default script